<template>
	<div>
		<span
			class="ao-preview-status ao-p4-medium d-flex align-center"
			:class="customClass"
		>
		<slot name="content">

			<slot name="icon">
				<ao-icon
					v-if="iconName"
					:iconName="iconName"
					class="mr-2"
				/>
			</slot>

			{{ status }}

			<slot />

		</slot>
		</span>
	</div>
</template>

<script>
export default {
	name: 'PreviewStatus',

	props: {
		status: {
			type: String,
		},
		color: {
			type: String, //green, Blue
		},
		iconName: {
			type: String,
		},
	},
	computed: {
		customClass() {
			let prefix = 'ao-preview-status-'
			let customClass = ''
			if (this.color) {
				customClass = prefix + this.color
			}
			return customClass
		},
	},
}
</script>

<style lang="scss">
.ao-preview-status {
	padding: 4px 8px;
	border-radius: 4px;
	width: fit-content;
	&.ao-preview-status-green {
		background: #ddf0e3;
		color: #42a162;
	}
	&.ao-preview-status-blue {
		background: #ecf1f7;
		color: #4a86c7;
	}
	&.ao-preview-status-red {
		background: #f9d8d1;
		color: rgb(var(--v-theme-error));
	}
	&.ao-preview-status-orange {
		background: #faf4e6;
		color: rgb(var(--v-theme-warning)); //#EAB631
	}
	&.ao-preview-status-gray {
		background: #dee6e8;
		color: #576674;
	}
}
</style>
